import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { TIconFromRenderingParams } from '../../../types/types';
import {
  TCHModelDetailNavigationSectionFields,
  TCHModelDetailNavigationSectionInnerComponents,
  TCHModelDetailNavigationSectionProps,
} from '../types/productModelNavigation.types';

export class CHModelDetailNavigationSectionModel {
    private readonly fields: TCHModelDetailNavigationSectionFields;
    private readonly rendering?: ComponentRendering;

    constructor(props: TCHModelDetailNavigationSectionProps) {
        this.fields = props?.fields || null;
        this.rendering = props?.rendering;
    }

    get thumbnailEE(): string {
        return this.fields?.itemData?.thumbnail || '';
    }

    get componentName(): string {
        return this.rendering?.componentName || '';
    }

    get innerComponents(): TCHModelDetailNavigationSectionInnerComponents[] {
        const innerComp = this.fields?.apiData?.innerComponents;
        innerComp && innerComp.splice(4);
        return innerComp && innerComp?.length ? innerComp : [];
    }

    get iconsList(): Array<TIconFromRenderingParams> {
        return this.fields?.itemData?.iconsList || [];
    }

    get isUnreleased(): boolean {
        return !!this.fields?.isComponentUnreleased;
    }
}
